
import LeftSide from "../Components/AiComponents/modules/frequentTopic/LeftSide";
import LandingLayout from "../layouts/LandingLayout";
import Content from "../Components/AiComponents/modules/frequentTopic/Content";
import RightSide from "../Components/AiComponents/modules/frequentTopic/RightSide";

function FrequentTopics() {
  return (
    <>
      <LandingLayout className="bg-black">
        <div className="w-full flex px-5 justify-between mt-24">
            <LeftSide />
            <Content />
            <RightSide />
        </div>
      </LandingLayout>
    </>
  );
}

export default FrequentTopics;
